
    <overlay-loading *ngIf="startLoading$ | async"></overlay-loading>

    <main *ngIf="!(startLoading$ | async)">
      <acceptance-terms-modal *ngIf="user"></acceptance-terms-modal>
      <voucher-alert-modal
        [vouchers]="vouchers$ | async"
        [inviteAccepts]="totalInvites$ |async"
        [voucherProvider]="voucherProvider$ | async"
        *ngIf="canShowVoucherModal && !(vouchersLoading$ | async) && !(mgmConfigLoading$ | async) && !(invitesLoading$ | async)"
      ></voucher-alert-modal>
      <toaster></toaster>
      <establishment-redirection></establishment-redirection>
      <router-outlet></router-outlet>
      <platform-access-blocked-modal></platform-access-blocked-modal>
    </main>
  